import React, { useState, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid, Box, TextField } from '@mui/material';
import AxiosInstance from '../../server/AxioInstance';
import { useSnackbar } from '../../shared/context';

const AlertDialogSlide = ({ handleClose, handleCancel, dialogData }) => {
  const { showSnackbar } = useSnackbar();
  const disabled = dialogData.item.finished_review === false ? true : false;
  const [formData, setFormData] = useState({
    id_document: dialogData.item.document_number,
    title: dialogData.item.title,
    reason: dialogData.item.reason,
    login: localStorage.getItem('@gedy:user'),
  });

  const reasonRef = useRef(null); // Referência para o TextField do motivo

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFormSubmit = async () => {
    if (formData.reason.trim() === '') {
      showSnackbar({
        vertical: 'top',
        horizontal: 'right',
        message: 'Por favor, forneça uma justificativa para a revisão do documento.',
        variant: 'error',
      });
      reasonRef.current.focus();
    } else {
      try {
        const result = await AxiosInstance.post(
          '/manipulate-documents/revision-document',
          formData,
        );
        showSnackbar({
          vertical: 'top',
          horizontal: 'right',
          message: result.data,
          variant: 'success',
        });
        handleClose();
      } catch (error) {
        showSnackbar({
          vertical: 'top',
          horizontal: 'right',
          message: error.response.data,
          variant: 'error',
        });
      }
    }
  };

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        {dialogData.item.finished_review === false
          ? 'Documento já foi solicitado revisão por: ' + dialogData.item.reviewer
          : 'Solicitar a revisão do documento'}
      </DialogTitle>
      <DialogContent>
        <Box p={2}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Título do Documento"
                variant="outlined"
                name="title"
                fullWidth
                margin="normal"
                required
                value={formData.title}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Motivo da revisão"
                variant="outlined"
                name="reason"
                multiline
                rows={4}
                fullWidth
                margin="normal"
                color="primary"
                required
                value={formData.reason}
                inputRef={reasonRef}
                onChange={handleInputChange}
                disabled={disabled}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} variant="contained" color="error">
          Cancelar
        </Button>
        <Button onClick={handleFormSubmit} variant="contained" color="success" disabled={disabled}>
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialogSlide;
